import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { utils } from '@atlaskit/util-service-support';
import { timed } from './timing';
import { limitToMaxSiteUsage } from './multi-site-utils';
import { sitesToLocations, SEARCH_QUERY } from './graphql-tools';
export { CONFLUENCE_ITEM_ENTITIES } from './graphql-tools';
export class GraphQLClient {
  constructor({
    url,
    cloudId,
    siteMasterList
  }) {
    _defineProperty(this, "makePostRequest", (path, body) => {
      const options = {
        path,
        requestInit: {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        }
      };
      return utils.requestService(this.serviceConfig, options);
    });
    this.serviceConfig = {
      url: url
    };
    this.cloudId = cloudId;
    this.siteMasterList = siteMasterList;
  }
  async search({
    query,
    // todo
    context,
    entities,
    // todo
    modelParams,
    // todo
    resultLimit,
    filters,
    experience,
    sites = []
  }) {
    const cloudId = this.cloudId;
    const cloudIdsToFilterOn = sites.length > 0 ? sites : limitToMaxSiteUsage(this.siteMasterList).map(site => site.cloudId);
    const locations = sitesToLocations(cloudIdsToFilterOn, cloudId);
    const body = {
      query: SEARCH_QUERY,
      variables: {
        locations,
        entities,
        query,
        confluenceFilters: filters,
        experience
      }
    };
    const {
      result: response,
      durationMs: requestDurationMs
    } = await timed(this.makePostRequest(GraphQLClient.GRAPHQL_API_URL, body));
    return {
      response: {
        rawData: response
      },
      requestDurationMs
    };
  }
}
// Static URLs
_defineProperty(GraphQLClient, "GRAPHQL_API_URL", 'graphql');